module.exports = __webpack_public_path__ + "static/media/thumbnail@2x.951585ef.png";